import { render, staticRenderFns } from "./FbVideoView.vue?vue&type=template&id=3eed734b&scoped=true"
import script from "./FbVideoView.vue?vue&type=script&lang=js"
export * from "./FbVideoView.vue?vue&type=script&lang=js"
import style0 from "./FbVideoView.vue?vue&type=style&index=0&id=3eed734b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed734b",
  null
  
)

export default component.exports